import React from "react";
import { Box } from '@mui/joy';
import { Pie } from 'src/mtska-frontend-app-component';

const PiePotential = ({ user, filters, createSliceFilterHandler, handleFilterChange, t }) => {
    return (
        <Box className="highligtedSection" style={{ marginTop: '40px' }}>
            <Box className="dashboard-section-title">
                <h2>{t('Potenziale flotta aggredibile per tipologia cliente')}</h2>
            </Box>
            <Box className="dashboard-menu-itemgroup dashboard-menu-itemgroup-pie" sx={{ marginTop: '30px' }}>
                <Box className="dashboard-menu-item">
                    <Pie
                        title={<>{t("Potenziale aggredibile")}<br></br>{t("Clienti VIP")}</>}
                        dataProviderName={"statisticsviews/potvsact_general/potentialvsactual/views_cars_car"}
                        filters={{
                            items: [
                                ...(filters?.items || []),
                                {
                                    field: "_related_legalEntity_commercialCluster",
                                    operator: "equals",
                                    value: "VIP (OVER 50)"
                                }
                            ]
                        }}
                        monochrome={{
                            enabled: true,
                            color: '#52b5f1',
                            shadeTo: 'dark',
                            shadeIntensity: 1
                        }}
                        donutWidth={250}
                        height={200}
                    //handleFilterChange={createSliceFilterHandler('_related_contract_orderPurchaseType', handleFilterChange)}
                    />
                </Box>
                <Box className="dashboard-menu-item">
                    <Pie
                        title={<>{t("Potenziale aggredibile")}<br></br>{t("Clienti TOP")}</>}
                        dataProviderName={"statisticsviews/potvsact_general/potentialvsactual/views_cars_car"}
                        filters={{
                            items: [
                                ...(filters?.items || []),
                                {
                                    field: "_related_legalEntity_commercialCluster",
                                    operator: "equals",
                                    value: "TOP (21-50)"
                                }
                            ]
                        }}
                        monochrome={{
                            enabled: true,
                            color: '#52b5f1',
                            shadeTo: 'dark',
                            shadeIntensity: 1
                        }}
                        donutWidth={250}
                        height={200}
                    //handleFilterChange={createSliceFilterHandler('_related_contract_orderPurchaseType', handleFilterChange)}
                    />
                </Box>

                <Box className="dashboard-menu-item">
                    <Pie
                        title={<>{t("Potenziale aggredibile")}<br></br>{t("Clienti MEDIUM")}</>}
                        dataProviderName={"statisticsviews/potvsact_general/potentialvsactual/views_cars_car"}
                        filters={{
                            items: [
                                ...(filters?.items || []),
                                {
                                    field: "_related_legalEntity_commercialCluster",
                                    operator: "equals",
                                    value: "MEDIUM (6-20)"
                                }
                            ]
                        }}
                        monochrome={{
                            enabled: true,
                            color: '#52b5f1',
                            shadeTo: 'dark',
                            shadeIntensity: 1
                        }}
                        donutWidth={250}
                        height={200}
                    //handleFilterChange={createSliceFilterHandler('_related_contract_orderPurchaseType', handleFilterChange)}
                    />
                </Box>
                <Box className="dashboard-menu-item">
                    <Pie
                        title={<>{t("Potenziale aggredibile")}<br></br>{t("Clienti SMALL")}</>}
                        dataProviderName={"statisticsviews/potvsact_general/potentialvsactual/views_cars_car"}
                        filters={{
                            items: [
                                ...(filters?.items || []),
                                {
                                    field: "_related_legalEntity_commercialCluster",
                                    operator: "equals",
                                    value: "SMALL (2-5)"
                                }
                            ]
                        }}
                        monochrome={{
                            enabled: true,
                            color: '#52b5f1',
                            shadeTo: 'dark',
                            shadeIntensity: 1
                        }}
                        donutWidth={250}
                        height={200}
                    //handleFilterChange={createSliceFilterHandler('_related_contract_orderPurchaseType', handleFilterChange)}
                    />
                </Box>
            </Box>
        </Box>
    )
}

export default PiePotential